(ns ductile.ui.invoices
  (:require [clojure.string :as str]
            [ductile.ui.billing :as billing]
            [ductile.ui.components :as ui]
            [ductile.ui.components.combobox :as combobox]
            [ductile.ui.deframe :as deframe]
            [ductile.ui.http :as http]
            [ductile.ui.icons :as icons]
            [ductile.ui.locale :refer [tr]]
            [ductile.ui.util :as util]
            [inside-out.forms :as forms]
            [inside-out.reagent :refer [with-form]]
            [nextjournal.clerk.render :as render]
            [nextjournal.clerk.render.hooks :as hooks]
            [nextjournal.clerk.viewer :as viewer]
            [reagent.core :as reagent]))


(defn billing-checkbox [?invoice-types checkbox-id title]
  [:label.flex.items-center.gap-2
   {:for (str checkbox-id)}
   [:input {:type "checkbox"
            :id (str checkbox-id)
            :checked (boolean (@?invoice-types checkbox-id))
            :on-change (fn [event]
                         (if (.. event -target -checked)
                           (swap! ?invoice-types conj checkbox-id)
                           (swap! ?invoice-types disj checkbox-id)))}]
   title])




(defn export-link [{:as form} export-type]
  (str "invoices/export?"
       (util/map->url-encoded-query-params (-> form
                                               (assoc :export-type export-type)))))


(defn invoice-form [{:as args :keys [contracts on-submit params]}]
  (let [{:keys [billing-types contract-id compounds invoice-number] :or {billing-types #{}
                                                                         compounds #{}}} params
        current-date (js/Date.)
        _ (.setMonth current-date (- (.getMonth current-date) 1))
        available-compounds (into #{} (mapcat #(mapcat (fn [template]
                                                         (map :compound/name (:ductile/compounds template)))
                                                       (:contract/billing-templates %))
                                              contracts))]
    (with-form [!form {:billing-template-name ?billing-template-name
                       :invoice-number ?invoice-number
                       :contract-id ?contract-id
                       :contract-name ?contract-name
                       :billing-year-month ?billing-year-month

                       :billing-types ?billing-types
                       :compounds ?compounds}
                :init {?billing-types billing-types
                       ?contract-id contract-id
                       ?compounds compounds
                       ?invoice-number invoice-number}
                :required []]
      [:div.rounded-lg.border.border-slate-300.shadow-lg.mx-auto.max-w-4xl
       {:class (when (not (str/blank? @?invoice-number))
                 " text-gray-400")}
       [:div.px-5.py-2.bg-slate-100.border-b.border-slate-300.rounded-t-md
        [:div.text-base.font-bold (tr "Invoice search")]]
       [:form.bg-slate-50
        {:on-submit (fn [event]
                      (.preventDefault event)
                      (forms/try-submit+
                       !form
                       (when on-submit
                         (on-submit @!form))))}
        [:div.flex.gap-6.border-b.p-6
         [:div
          [:div.uppercase.tracking-wide.text-xs.mb-2.font-medium
           (tr "Billing month")]
          [:div
           (let [current-month (.getMonth (js/Date.))
                 month-names [(tr "January") (tr "February") (tr "March") (tr "April")
                              (tr "May") (tr "June") (tr "July") (tr "August")
                              (tr "September") (tr "October") (tr "November") (tr "December")]
                 choices (concat
                          [{:ui/value nil :ui/label (str (tr "any")
                                                         (str/join (repeat 10 "\u2004")))}]
                          (reverse (map #(let [billing-month (js/Date.)
                                               ;; if it is e.g. the 31th of July and we set the month to
                                               ;; June first, the 31th of June does not exist and results
                                               ;; in the 1th of July which is not what we want. We need to
                                               ;; set the day to the middle of the month to avoid for that
                                               _ (.setDate billing-month 15)
                                               _ (.setMonth billing-month %)
                                               month (+ 1 (.getMonth billing-month))
                                               month-name (get month-names (.getMonth billing-month))
                                               month (if (<= 10 month) (str month) (str "0" month))
                                               year (.getFullYear billing-month)]
                                           {:ui/value (str year "-" month) :ui/label (str month-name " " year)})
                                        (range (- current-month 12) (inc current-month)))))]
             [combobox/view
              {:placeholder (tr "Select billing month")
               :size 3
               :choices choices
               :value (some #(when (= @?billing-year-month (:ui/value %)) %) choices)
               :on-change #(reset! ?billing-year-month (:ui/value %))}])]]
         [:div
          [:div.uppercase.tracking-wide.text-xs.mb-2.font-medium
           (tr "Invoice content")
           [:span.normal-case.font-medium.text-gray-500.text-xs.ml-2 (cond
                                                                       (= 1 (count @?billing-types)) (tr "only invoices containing …")
                                                                       (< 1 (count @?billing-types)) (tr "only invoices containing … and …")
                                                                       :else (tr "any"))]]


          [:ul.items-center.w-full.text-sm.font-medium.bg-white.border.border-gray-200.rounded-lg.sm:flex.py-2.px-5
           [:li.px-5 [billing-checkbox ?billing-types :billing.type/services (tr "Services")]]
           [:li.px-5 [billing-checkbox ?billing-types :billing.type/storage (tr "Storage")]]
           [:li.px-5 [billing-checkbox ?billing-types :billing.type/accessory-storage (tr "Accessory Storage")]]
           [:li.px-5 [billing-checkbox ?billing-types :billing.type/transports (tr "Transports")]]]]]

        [:div.flex.gap-6.border-b.p-6
         [:div
          [:div.uppercase.tracking-wide.text-xs.mb-2.font-medium
           (tr "Locations")
           [:span.normal-case.font-medium.text-gray-500.text-xs.ml-2 (cond
                                                                       (= 1 (count @?compounds)) (tr "only invoices for …")
                                                                       (< 1 (count @?compounds)) (tr "only invoices for … and …")
                                                                       :else (tr "any"))]]
          (into [:ul.items-center.w-full.text-sm.font-medium.bg-white.border.border-gray-200.rounded-lg.sm:flex.py-2.px-5]
                (mapv #(identity [:li.px-5 [billing-checkbox ?compounds % %]]) available-compounds))]]

        [:div.flex.gap-6.border-b.p-6
         [:div
          [:div.uppercase.tracking-wide.text-xs.mb-2.font-medium
           (tr "Customer order")]
          [:div
           (let [choices (concat [{:ui/value nil :ui/label (str (tr "any")
                                                                (str/join (repeat 30 "\u2004")))}] ;; DODO: replace by using width of longest item
                                 (map #(identity {:ui/value (:ductile/id %) :ui/label (:contract/name %)}) contracts))]
             [combobox/view
              {:placeholder (tr "Select customer order")
               :size 3
               :choices choices
               :value (some #(when (and (= @?contract-id (:ui/value %))
                                        (= @?contract-name (:ui/label %))) %) choices)
               :on-change #(do (reset! ?contract-id (:ui/value %))
                               (reset! ?contract-name (:ui/label %))
                               (reset! ?billing-template-name nil))}])]]

         (when @?contract-id
           [:div
            [:div.uppercase.tracking-wide.text-xs.mb-2.font-medium
             (tr "Billing")]
            [:div
             (let [choices (when-let [{:as contract} (some #(when (and (= @?contract-id (:ductile/id %))
                                                                       (= @?contract-name (:contract/name %))) %)
                                                           contracts)]
                             (into [{:ui/value nil :ui/label (str (tr "any") (str/join (repeat 45 "\u2004")))}]
                                   (map (fn [template-name]
                                          {:ui/value template-name
                                           :ui/label template-name}))
                                   (->> (:contract/billing-templates contract)
                                        (map :billing-template/name)
                                        set sort)))]

               [combobox/view
                {:placeholder (tr "Select billing")
                 :size 3
                 :choices choices
                 :value (some #(when (= @?billing-template-name (:ui/value %)) %) choices)
                 :on-change #(reset! ?billing-template-name (:ui/value %))}])]])]
        [:div.flex.gap-6.border-b.p-6
         [:div
          [:div.uppercase.tracking-wide.text-xs.mb-2.text-black
           {:class (if (not (str/blank? @?invoice-number))
                     " font-bold"
                     " font-medium")}
           (tr "Invoice Number")]
          [:div
           [ui/input
            {:value @?invoice-number
             :on-input #(reset! ?invoice-number (.. % -target -value))
             :size 3}]]]]




        [:div.px-6.py-3.flex.items-center.gap-2.bg-slate-100
         [ui/button {:variant :primary :size 3 :type "submit"} (tr "Search")]
         [:div.flex.items-center
          [ui/button
           {:variant :white
            :size 3
            :href (export-link @!form "xlsx")
            :class "rounded"}
           [:div.flex.items-center.gap-2
            icons/excel
            (tr "Download")]]]]]])))




(defn render-invoice-list [{:keys [invoices]}]
  [:div
   (when invoices
     (if (< 0 (count (:rows invoices)))
       [:div.mb-8.mx-auto.max-w-8xl
        [:h4.mb-4 (tr "Invoices")]
        [render/inspect (viewer/table invoices)]]
       [:div.bg-white.md:rounded-lg.w-6xl.mx-auto.mt-4.md:my-6.shadow-lg
        [:div.mb-8
         [ui/flash-notice {:type :info :message [:div
                                                 [:div.font-bold (tr "No invoices found")]
                                                 [:div.mt-2
                                                  [:ul.list-disc.pl-5.space-y-1
                                                   [:li (tr "Try to relax the filtering criteria a bit.")]]]]
                           :on-close #(.preventDefault %)}]]]))])


(defn render-list [_result {:as match :keys [query-params]}]
  (let [choices (http/use-lambda 'ductile.invoices/fetch-choices {:compound-name "Krefeld"})
        !results-promise (hooks/use-state nil)
        on-preview (fn [params]
                     (.pushState js/window.history nil nil (str "?" (util/map->url-encoded-query-params (-> params
                                                                                                            (update :contract-id #(when % (with-out-str (prn %))))))))
                     (reset! !results-promise (http/$lambda 'ductile.invoices/$list params)))
        params-from-query (-> query-params
                              (util/parse-query-params #{:billing-year-month :customer-name :customer-id :export-type :invoice-number})
                              (dissoc :export-type))]
    (hooks/use-effect (fn []
                        (when (seq params-from-query)
                          (on-preview params-from-query))))
    [:div.p-5
     [invoice-form (merge choices
                          {:params params-from-query}
                          {:on-submit on-preview})]
     (when @!results-promise
       [:div.w-full.flex.justify-center.items-center.pt-10
        [ui/loading-promise-view render-invoice-list @!results-promise]])]))


(defn render-show [_result {:keys [path-params] :as _match}]
  (let [{:keys [invoice-number]} path-params
        {:keys [result error]} @deframe/!current-route-fetch
        !invoice-cancellation-result (hooks/use-state nil)
        !generating-cancellation? (reagent/atom false)
        on-cancel (fn [params]
                    (reset! !invoice-cancellation-result nil)
                    (let [promise (http/$lambda 'ductile.billing/$cancel! params)]
                      (.then promise #(do
                                        (reset! !generating-cancellation? false)
                                        (reset! !invoice-cancellation-result (cond
                                                                               (seq (:billing-error %)) :failed
                                                                               (:credit-note-invoice-id %) :succeeded))
                                        (deframe/route-assoc! :fetch {:result %})))))]

    (if error
      [ui/error-view error]
      [billing/render-preview (merge result
                                     {:on-cancel on-cancel
                                      :invoice-number invoice-number
                                      :!generating-cancellation? !generating-cancellation?
                                      :!invoice-cancellation-result !invoice-cancellation-result})])))
